<template>
    <div class="mx-auto w-full max-w-screen-3xl p-3.5 pt-2.5 md:p-6 md:pt-4 !pb-0 flex justify-between">
        <div class="flex items-center">
            <exit-button />

            <p
                v-if="isReviewStep"
                class="ml-4 text-xs sm:text-sm font-freizeit"
            >
                {{ $t('DOUBLE_CHECK') }}
            </p>
        </div>

        <proof-button :class="{ 'invisible': !isSelectStep }" />
    </div>
</template>

<script>
    import * as constants from '../constants';

    import allStores from '../stores/all';

    import ExitButton from './ExitButton.vue';
    import ProofButton from './ProofButton.vue';

    export default {
        mixins: [allStores],

        components: {
            ExitButton,
            ProofButton,
        },

        computed: {
            isSelectStep() {
                return this.currentStep !== constants.STEP_PERSONALIZE;
            },

            isReviewStep() {
                return this.currentStep === constants.STEP_REVIEW;
            },

            currentStep() {
                return this.appStore.currentStep;
            },
        },
    };
</script>
